// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD37nVsRDlowm4Juxx_K50dy2dCGwVAyZs",
  authDomain: "curlsgonewild.firebaseapp.com",
  projectId: "curlsgonewild",
  storageBucket: "curlsgonewild.appspot.com",
  messagingSenderId: "875129868077",
  appId: "1:875129868077:web:282855e98bed411ff14da4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
